<template>
  <slider-layout is-show-overlay gray-bg>
      <div class="col-lg-10 ml-auto mr-auto mt-3">

              <card>
                <button type="button" class="pull-right close" @click="$router.push('/home')">X</button>
              <h4 class="header text-center">비밀번호 변경</h4>
              <hr class="mb-4"/>
              <el-form @submit.native.prevent="submitForm('ruleForm')" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" class="mr-5">
                <p class="text-center mb-4 fs15 text-primary2">임시 발급해 드린 비밀번호를 변경하셔야 서비스를 이용하실 수 있습니다.
                </p>
                <hr class=""/>

                <el-form-item label="임시 발급된 비밀번호" prop="oldPassword" required>
                  <el-input type="password" v-model="ruleForm.oldPassword" ></el-input>
                </el-form-item>
                
                <el-form-item label="신규 비밀번호" prop="password" required>
                  <el-input type="password" v-model="ruleForm.password" ></el-input>
                </el-form-item>
                <el-form-item label="신규 비밀번호 확인" prop="confirmPassword" required>
                  <el-input type="password" v-model="ruleForm.confirmPassword" ></el-input>
                </el-form-item>

                <el-form-item class="text-right mt-5">
                  <el-button native-type="submit" type="primary" icon="el-icon-lock">비밀번호 변경</el-button>
                  <el-button @click="$router.push('/home')" icon="el-icon-house">메인으로 이동</el-button>
                </el-form-item>
                
              </el-form>
              </card>
      </div>
  </slider-layout>

</template>              
<script>
  import JoinInfoProtectionModal from '../Common/JoinInfoProtectionModal.vue';
  import AppFooter from 'src/components/Pages/Views/Layout/AppFooter'
  import SearchCompany from '@/components/Pages/Views/Common/SearchCompany.vue'
  import TelInput from '@/components/Pages/Views/Common/TelInput.vue'
  import SabunInput from '@/components/Pages/Views/Common/SabunInput.vue';
  import CommonProxy from '@/proxies/CommonProxy';
  import * as Util from '@/util/util'
  import _ from 'lodash'
import AuthProxy from '@/proxies/AuthProxy';
import JSEncrypt from 'jsencrypt';
import SliderLayout from './Layout/SliderLayout.vue';


  const validator =({required, onlyWord, domain, min, confirmPassword, phone, captcha, tel, pwd}, vm) => {

    return (rule, value, callback) => {
      
      if(required && !value) {
        callback( new Error('필수입력 항목입니다.'))
        return
      } else if(onlyWord && !/^[\w\-\.]+$/g.test(value) ) {
          callback( new Error('영문만 가능합니다.'))
          return
      } else if(pwd && !/^(?=.*?[#?!@$ %^&*-]).{6,}$/.test(value)) {
          callback( new Error(`특수 문자 포함 6자 이상 입력하세요.`))
          return
      } else if(min && value.length < min ) {
          callback( new Error(`최소 ${min}자리 이상 이어야 합니다.`))
          return
      } else if(confirmPassword && value !== vm.ruleForm[confirmPassword] ) {
          callback( new Error('비밀번호가 일치하지 않습니다.'))
          return
      } else {
        callback()
      }

      
    }

  } 

  export default {
    components: {
      AppFooter, SliderLayout
    },
    created() {
      
    },
    mounted() {

    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
              if (valid) {

                const proxy = new AuthProxy()
                proxy
                .publicKey()
                .then((response) => {

                  const user = { ...this.ruleForm }
                  const encrypt = new JSEncrypt()
                  encrypt.setPublicKey(response.publicKey)
                  user.oldPassword = encrypt.encrypt(user.oldPassword)
                  // user.password = encrypt.encrypt(user.password)

                  return user

                })
                .then(user=> {

                  new CommonProxy()
                  .changePw( user )
                  .then(response => {
                    if(!response.success) {
                      alert(response.header.resultMessages)
                    } else {
                      alert('비밀번호변경이 완료됐습니다.\n새로운 비밀번호로 로그인 후 이용하시기 바랍니다.')
                      this.$router.push('/home')
                    }
                  })

                })

              } else {
                  alert('필수항목을 올바르게 입력해주세요')
                  return false;
              }
            })
        },
    },
    computed: {
    },
    data() {
      return {
        ruleForm: {
          companySeq: '',
          userId: '',
          oldPassword: '',
          password: '',
          confirmPassword: '',
        },
        rules: {
          oldPassword: [
            { trigger: 'blur', validator: validator({ required: true}) },
            { trigger: 'change', validator: validator({ required: true}) }
          ],
          password: [
            { trigger: 'blur', validator: validator({ required: true, pwd: true, min: 6 }) },
            { trigger: 'change', validator: validator({ required: true, pwd: true, min: 6 }) }
          ],
          confirmPassword: [
            { trigger: 'blur', validator: validator({ required: true, confirmPassword: 'password' }, this) },
            { trigger: 'change', validator: validator({ required: true, confirmPassword: 'password'}, this) }
          ],

        }
      }
    }
  }
</script>
<style>
  .join-page {
    background-image: url(/static/commons/images/main_bg.jpg);
    min-height: 100vh;
    background-size: cover;
  }  
  .join-page .logo {width: 221px;height: 64px;background: url("/static/commons/images/main_logo.png") no-repeat; margin:0 auto;position: absolute;background-size: contain;z-index: 1000;margin: 30px;}

  .join-page .card label {
    color: #606266;
    font-size: 14px;
  }

</style>
